"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.TopLabel = styled_components_1.default(react_native_1.Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: #9298a1;\n    font-size: 12px;\n    font-family: Roboto;\n    line-height: 14px;\n    text-align: center;\n    text-transform: uppercase;\n"], ["\n    color: #9298a1;\n    font-size: 12px;\n    font-family: Roboto;\n    line-height: 14px;\n    text-align: center;\n    text-transform: uppercase;\n"])));
exports.TileGroupRow = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    ", "\n"], ["\n    width: 100%;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            margin-bottom: " + (small ? '24px' : '41px') + ";\n            " + (!small && 'min-width: 660px;') + "\n        ";
});
exports.FormInputGroup = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap\n    align-items: center;\n    justify-content: center;\n    width: ", ";\n"], ["\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap\n    align-items: center;\n    justify-content: center;\n    width: ", ";\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return responsive_1.isSmall(activeBreakpoint) ? '80%' : '350px';
});
exports.TileButtonWrapper = styled_components_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: center;\n    padding-top: 50px;\n"], ["\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: center;\n    padding-top: 50px;\n"])));
exports.FormInputLinkContainer = styled_components_1.default(react_native_1.View)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin: 8px 0;\n"], ["\n    margin: 8px 0;\n"])));
exports.StepButtonsWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    justify-content: space-around;\n    align-items: center;\n    ", "\n"], ["\n    justify-content: space-around;\n    align-items: center;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var small = responsive_1.isSmall(activeBreakpoint);
  return "\n            width: " + (small ? '100%' : '334px') + ";\n            height: " + (small ? '120px' : 'auto') + ";\n            flex-direction: " + (small ? 'column-reverse' : 'row') + ";\n        ";
});
exports.TermsWrapper = styled_components_1.default(react_native_1.View)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n    flex: 0 1 auto;\n"], ["\n    width: 100%;\n    flex: 0 1 auto;\n"])));
exports.AuthButtonsContainer = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin: 24px 0;\n"], ["\n    margin: 24px 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;